module.exports = __webpack_public_path__ + "img/cons_8.ddbb2ea2.jpg";